var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4",
    "data-name": "Group 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.038,
    height: 17.002,
    viewBox: "0 0 17.038 17.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M5.082,11.531A4.248,4.248,0,0,1,7.863,4.819a.355.355,0,0,0,.3-.351V.895A.355.355,0,0,0,8.049.633a.348.348,0,0,0-.27-.092A8.511,8.511,0,0,0,2,14.5a.354.354,0,0,0,.257.126h.015a.355.355,0,0,0,.251-.1l2.528-2.528A.355.355,0,0,0,5.082,11.531Z",
    transform: "translate(0 -0.54)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M94,.544A.355.355,0,0,0,93.614.9V4.471a.355.355,0,0,0,.3.351,4.256,4.256,0,1,1-3.165,7.639.355.355,0,0,0-.46.035l-2.528,2.528a.354.354,0,0,0,.023.523A8.516,8.516,0,1,0,94,.544Z",
    transform: "translate(-84.741 -0.543)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.3645458a87f057bcfe45a711498b2d79.svg";
export { ForwardRef as ReactComponent };